import React from "react";
import { MessageContainer } from "./styled/common";
import { useNavigate } from "react-router";

const Message = ({ url, homepageInfo = null }) => {
  const navigate = useNavigate();

  const companyLogo = () => {
    if (!url && !homepageInfo) {
      return <img src="/img/logo.png" onClick={() => navigate("/")} className="monoti" />;
    } else {
      if (homepageInfo?.logoImage) {
        return (
          <img
            src={imgHandler(homepageInfo.logoImage)}
            onClick={() => navigate("/")}
            className="shop"
          />
        );
      } else {
        return <h3>{homepageInfo?.logoText || homepageInfo?.cmpnyNm}</h3>;
      }
    }
  };

  return (
    <MessageContainer>
      {companyLogo()}
      <span>
        회원이 되시면 더 많은 혜택을
        <br />
        경험할 수 있습니다
      </span>
    </MessageContainer>
  );
};

export default Message;
